import classnames from 'classnames'
import { PavingStoneBigger } from '@icons'
import Image from 'next/image'
import { forwardRef } from 'react'

import CTAButton from '../../button'
import TalentEmpowerImage from '../../../assets/pngs/talent-hero.png'

import styles from './styles.module.scss'

type EmpowerSectionProps = {
  className?: string
}

export const EmpowerSection = forwardRef<HTMLElement, EmpowerSectionProps>(({ className }, ref) => {
  return (
    <section className={classnames(styles['empower-section-container'], className)} ref={ref}>
      <div className={styles['empower-section-wrapper']}>
        <div className={styles['section-content']}>
          <h1 className={styles['section-title']}>
            We empower you to thrive. <span className={styles['text-decorator']}>Every day.</span>
          </h1>
          <p className={styles['section-text']}>
            Work from anywhere, connect and engage with like-minded experts, and do meaningful work
            for American companies. Join our team and explore the amazing opportunities Olby has to
            offer now!
          </p>
        </div>
        <CTAButton variant="white" className={styles['join-olby']} href="/talent" prefetch={false}>
          join Olby
        </CTAButton>
        <CTAButton
          variant="white"
          size="medium"
          className={styles['mobile-join-olby']}
          href="/talent"
          prefetch={false}
        >
          join Olby
        </CTAButton>
        <div className={styles['media-container']}>
          <div className={styles['desktop-viewport-image']}>
            <Image
              src={TalentEmpowerImage}
              alt="Talent on the top of a mountain"
              className={styles['image']}
            />
          </div>
          <PavingStoneBigger className={styles['paving-stone-lines']} />
        </div>
      </div>
    </section>
  )
})

export default EmpowerSection
